import { render, staticRenderFns } from "./mobileSemanticModal.vue?vue&type=template&id=2fcbf213"
import script from "./mobileSemanticModal.vue?vue&type=script&lang=js"
export * from "./mobileSemanticModal.vue?vue&type=script&lang=js"
import style0 from "./mobileSemanticModal.vue?vue&type=style&index=0&id=2fcbf213&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports